import m from 'mithril';
import './LightBox.css';

interface Attrs {
    imageUrls:string[],
    show: boolean,
    initialImageIndex?: number,
    onClose: () => void;
}

export default function LightBox(): m.Component<Attrs> {
    let dialogElem: any | null = null; 
    let showing = false;    
    let currImageIndex = 0;
    
    return {
        oncreate(vnode) {
            dialogElem = vnode.dom as any;
            dialogElem.addEventListener('close', (event) => {
                showing = false;
                vnode.attrs.onClose();
            });

            dialogElem.addEventListener('click', function (event) {                
                let rect = event.target.getBoundingClientRect();
                if (rect.left > event.clientX ||
                    rect.right < event.clientX ||
                    rect.top > event.clientY ||
                    rect.bottom < event.clientY
                ) {
                    dialogElem.close();
                    showing = false;
                    vnode.attrs.onClose();
                } 
            });

            if(vnode.attrs.show) {
                dialogElem.showModal();
                showing = true;
            }
        },

        oninit(vnode) {            
            if(vnode.attrs.initialImageIndex != null) {
                currImageIndex = vnode.attrs.initialImageIndex;
            }
        },

        onbeforeupdate(vnode, old) {
            if(!showing) {
                if(vnode.attrs.initialImageIndex != null) {
                    currImageIndex = vnode.attrs.initialImageIndex;
                }
            }
        },

        onupdate(vnode) {
            if(vnode.attrs.show && showing == false) {
                dialogElem.showModal();              
                showing = true;
            }            
        },

        view(vnode) {
            const {imageUrls, show, initialImageIndex, onClose} = vnode.attrs;
            return m("dialog.lightbox-modal", [                
                m("div.lightbox-modal-content", [
                    m("div", {
                        style:"flex-grow:1; _background-color: green;"
                    },                    
                        m("div.main-slide", {}, [
                            m("div.close-btn-area", 
                                m("a.close-btn text-white", {
                                    href:"#",
                                    onclick: (event) => {
                                        event.preventDefault();
                                        dialogElem.close();
                                        showing = false;
                                        onClose();
                                    }
                                }, [
                                    m("i.fas fa-times text-white")
                                ])                    
                            ),

                            m("div.previous-btn-area", 
                                m("a.previous-btn", {
                                    href:"#",
                                    onclick: (event) => {
                                        event.preventDefault();
                                        currImageIndex = (currImageIndex == 0)? 
                                            imageUrls.length - 1 : currImageIndex - 1;
                                    }
                                }, m.trust("&#10094;"))                    
                            ),
        
                            m("img.main-slide-img rounded-16", {
                                src : imageUrls[currImageIndex]
                            }),

                            /*m("div.main-slide-img", 
                                m("h1", "Index: " + currImageIndex)
                            ),*/
        
                            m("div.next-btn-area", 
                                m("a.next-btn", {
                                    href:"#",
                                    onclick: (event) => {
                                        event.preventDefault();
                                        currImageIndex = (currImageIndex == imageUrls.length - 1)? 
                                            0 : currImageIndex + 1;
                                    }
                                }, m.trust("&#10095;"))  
                            )
                        ]),                      
                    ),
    
                    m("div", {
                        "class" : "mt-1 img-thumb-grid"
                    }, 
                        imageUrls.map((imgUrl, index) =>                         
                            m("a", {
                                href:"#",
                                onclick: (event) => {
                                    event.preventDefault();
                                    currImageIndex = index;
                                }
                            },                                
                                m("img.img-thumb rounded", {
                                    src : imgUrl                                
                                })                       
                            )
                        )                
                    ),
                ])
            ]);
        }
    }
}